import ReactDOM from 'react-dom/client';
import { ForeePayProvider } from 'react-foree-pay-checkout';
import { HelmetProvider } from "react-helmet-async";
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import store, { persistor } from './store/store';
import './assets/css/themes.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <HelmetProvider>
          <ForeePayProvider useProduction={false}>
            <App />
          </ForeePayProvider>
        </HelmetProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
);
